export default "__VITE_ASSET__DKqP0n6U__"